import { NgModule } from '@angular/core';
import { CoreUiModule } from 'webcommon/core-ui';
import { FindControlModule } from 'webcommon/find-control';
import { MacroModule } from 'webcommon/macro';
import { HtmlEditorModule } from 'webcommon/html-editor';
import { WindowRef } from './attachment-approval/window-ref.service';
import {
  ApCcmComponent,
  AttachmentApprovalComponent,
  AttachmentApprovalDetailComponent,
  MessageReadMoreComponent,
} from './attachment-approval';
import {
  MessageStrikeoutModalComponent,
} from './message-strikeout';
import {
  MessageTaskComponent,
  MessageTaskModalComponent,
} from './message-task';
import {
  MessageNoteModalComponent,
} from './msg-note';
import {
  ApMessageEditorComponent,
  ApMessageThreadComponent,
  ApMessageThreadMessageComponent,
} from './ap-message';
import { MessageCenterFilterComponent } from './message-center';

const exportComponents = [
  ApCcmComponent,
  ApMessageEditorComponent,
  ApMessageThreadComponent,
  ApMessageThreadMessageComponent,
  AttachmentApprovalComponent,
  AttachmentApprovalDetailComponent,
  MessageCenterFilterComponent,
  MessageNoteModalComponent,
  MessageReadMoreComponent,
  MessageStrikeoutModalComponent,
  MessageTaskComponent,
  MessageTaskModalComponent,
];

const declareComponents = [
  exportComponents,
];

@NgModule({
  declarations: [
    declareComponents,
  ],
  exports: [
    exportComponents,
  ],
  imports: [
    CoreUiModule,
    FindControlModule,
    MacroModule,
    HtmlEditorModule
  ],
  providers: [WindowRef],
})
export class MessagesModule {

}
